import { Directive, HostListener, Input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[tooltipContext]',
  exportAs: 'tooltipContext',
})
export class TooltipWithContextDirective {
  @Input()
  tooltipContext: { [key: string]: any };

  constructor(private tooltip: NgbTooltip) {
    tooltip.triggers = null;
  }

  @HostListener('mouseover')
  private onMouseOver(): void {
    this.tooltip.open(this.tooltipContext);
  }

  @HostListener('mouseleave')
  private onMouseLeave(): void {
    if (this.tooltip.isOpen()) {
      this.tooltip.close();
    }
  }
}
